import { apiPut } from "../api/fetch";
import { endpoints } from "../utils/Constants";
import type { UserData } from "./useUserData";

type UpdateUserFields = {
  phonenumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

type UpdateUserEditableFields = {
  phonenumber: boolean;
  firstName: boolean;
  lastName: boolean;
  email: boolean;
};

export function buildUpdateUserPayload(
  userData: UserData,
  fields: UpdateUserFields,
  editable: UpdateUserEditableFields,
) {
  return {
    update_FirstName: editable.firstName,
    FirstName: fields.firstName ?? "",
    update_LastName: editable.lastName,
    LastName: fields.lastName ?? "",
    update_Phonenumber: editable.phonenumber,
    Phonenumber: fields.phonenumber ?? "",
    update_Email: editable.email,
    Email: fields.email ?? "",
    update_BirthDate: false,
    BirthDate: userData.birthDate ?? "",
    update_Locale: false,
    Locale: userData.locale ?? "",
  };
}

export async function updateUser(
  userData: UserData,
  fields: UpdateUserFields,
  editable: UpdateUserEditableFields,
) {
  const csrfToken = (
    document.getElementById("__HD_RequestVerificationToken") as HTMLInputElement
  )?.value;

  const payload = buildUpdateUserPayload(userData, fields, editable);
  await apiPut(endpoints.user.updateUser, payload, {
    headers: { "X-CSRF": csrfToken ?? "" },
  }).catch(() => {});
}
